import React, { PureComponent } from 'react'
import { Banner } from './Banner'

import { createCookie, readCookie } from '../../../utils/cookies'

// Hardcoded JSON for now
/*
Spec :
{
    "id": [Required] Unique id,
    "type": [Required] info / warning,
    "title": Bold title,
    "content": [Required] The banner first line text content,
    "learnMoreLink": A 'Learn More' link,
    "moreInfo": More detailed information which is initially collapsed
}
*/
const bannersData = [
  {
    id: 'snips-ico-upcoming',
    type: 'info',
    contentTitle: 'ICO',
    content: 'The Snips AIR token sale will start soon',
    learnMoreLink: 'https://ico.snips.ai'
  }
]

const productionDomain =
  typeof window !== 'undefined' && window.location.hostname.endsWith('snips.ai')
const dismissedBanners = []

export class BannersController extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      banners: []
    }
    this.dismissBanner = this.dismissBanner.bind(this)
    this.filterBanners = this.filterBanners.bind(this)
  }

  componentDidMount () {
    this.filterBanners()
  }

  getDismissedBanners () {
    if (!productionDomain) {
      return dismissedBanners
    }
    return JSON.parse(readCookie('dismissed-banners')) || []
  }

  dismissBanner (bannerId) {
    const dismissedBanners = this.getDismissedBanners()
    dismissedBanners.push(bannerId)
    if (productionDomain) {
      createCookie(
        'dismissed-banners',
        JSON.stringify(dismissedBanners),
        1000,
        '.snips.ai' // share across snips domains
      )
    }
    this.filterBanners()
  }

  filterBanners () {
    const dismissedBanners = this.getDismissedBanners()
    this.setState({
      banners: bannersData.filter(({ id }) => !dismissedBanners.includes(id))
    })
  }

  render () {
    const { banners } = this.state

    if (!banners || banners.length < 1) {
      return null
    }

    return (
      <div className='banners-controller main maxw-xxlarge mx-auto pb2'>
        {banners.map(banner => (
          <Banner key={banner.id} {...banner} onClose={this.dismissBanner} />
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/banners/BannersController.js